import ReportActionCell from "./ReportActionCell";

export const getReportColumns = () => [
  { field: "id", headerName: "ID", flex: 0.5, minWidth: 80 },
  { field: "reportType", headerName: "Report Type", flex: 1, minWidth: 150 },
  {
    field: "startTime",
    headerName: "Start Time",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "endTime",
    headerName: "End Time",
    flex: 1,
    minWidth: 160,
  },
  { field: "function", headerName: "Function", flex: 1, minWidth: 130 },
  { field: "route", headerName: "Route", flex: 1, minWidth: 130 },
  { field: "area", headerName: "Area", flex: 1, minWidth: 130 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
  // {
  //   field: "actions",
  //   headerName: "Actions",
  //   flex: 0.5,
  //   minWidth: 100,
  //   sortable: false,
  //   filterable: false,
  //   renderCell: (params) => <ReportActionCell row={params.row} />,
  // },
];
